( function ($) {
    $(document).ready(function () {
        var wrapper = $('.section_deform');
        if(wrapper.length > 0){
            wrapper.each(function(){
                var single_section = $(this);
                $(document).on('builderDeformEvent', function(){
                    var wrap = single_section.find('.request_form .wrap')
                    if (!wrap.hasClass('open')) {
                        single_section.find('.request_info').trigger('click');
                    } else {
                        var offset = wrap.offset().top - 100;
                        $('html,body').stop().animate({scrollTop: offset}, 500);
                    }
                    single_section.find('input[type="text"]').eq(0).focus();
                });
            });
        }
    });
}(jQuery));